export default __webpack_public_path__ + "static/media/nftLevel2Thumb.5583492a.jpg";